import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../resources/google-calendar.svg'
import _imports_1 from '../../resources/microsoft.svg'


const _withScopeId = n => (_pushScopeId("data-v-0f510876"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "callendar-setup" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "You've been Verified!", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sub-header__text" }, "Let's Connect Your Calendar!"),
  /*#__PURE__*/_createElementVNode("div", { class: "sub-header__description" }, "Connecting your calendar will allow you to easily let people know when you're available and when you're busy.")
], -1 /* HOISTED */))
const _hoisted_4 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_5 = {
  key: 1,
  class: "content-container"
}
const _hoisted_6 = {
  key: 0,
  class: "button-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "linked-confirmation" }, "Google Calendar Linked!", -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "button-container"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "google",
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-subtext" }, "Gmail or Workspace Calendar", -1 /* HOISTED */))
const _hoisted_13 = {
  key: 0,
  class: "button-container"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "linked-confirmation" }, "Microsoft Calendar Linked", -1 /* HOISTED */))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "button-container"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "microsoft",
  src: _imports_1
}, null, -1 /* HOISTED */))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-subtext" }, "Exchange, Office 365, Outlook", -1 /* HOISTED */))
const _hoisted_20 = { class: "tmp-link" }
const _hoisted_21 = { class: "trouble-connecting" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode($setup["VLoader"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!$setup.microsoftActive)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                ($setup.googleActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("button", {
                        class: "calendar-button",
                        onClick: $setup.doLinkGoogle
                      }, _hoisted_11),
                      _hoisted_12
                    ]))
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          (!$setup.googleActive)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                ($setup.microsoftActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("button", {
                        class: "calendar-button",
                        onClick: $setup.doLinkMicrosoft
                      }, _hoisted_18),
                      _hoisted_19
                    ]))
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", {
          class: "link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showCalendarVideo = true))
        }, "Having trouble connecting?")
      ]),
      _createElementVNode("button", {
        class: "outline next",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('progress')))
      }, "Next Page")
    ]),
    ($setup.showIntroVideo)
      ? (_openBlock(), _createBlock($setup["PopupVideo"], {
          key: 2,
          videoLink: "intro",
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.showIntroVideo = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showCalendarVideo)
      ? (_openBlock(), _createBlock($setup["PopupVideo"], {
          key: 3,
          videoLink: "calendar",
          onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.showCalendarVideo = false))
        }))
      : _createCommentVNode("v-if", true)
  ]))
}